/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Placewebphaseuploading3Inputs */

const en_placewebphaseuploading3 = /** @type {(inputs: Placewebphaseuploading3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading ${i?.count} photos`)
};

const de_placewebphaseuploading3 = /** @type {(inputs: Placewebphaseuploading3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Fotos werden hochgeladen`)
};

/**
* | output |
* | --- |
* | "Uploading {count} photos" |
*
* @param {Placewebphaseuploading3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphaseuploading3 = /** @type {((inputs: Placewebphaseuploading3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphaseuploading3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphaseuploading3(inputs)
	return de_placewebphaseuploading3(inputs)
});
export { placewebphaseuploading3 as "placeWebPhaseUploading" }